import { SVGProps } from './SVGProps';

const VolumeUserIcon = ({ fill = '#EFC6B6', width = '40', height = '40', ...rest }: SVGProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <circle cx="20" cy="20" r="20" fill="white" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M23.6304 16C23.6304 18.2091 21.7542 20 19.4398 20C17.1254 20 15.2492 18.2091 15.2492 16C15.2492 13.7909 17.1254 12 19.4398 12C21.7542 12 23.6304 13.7909 23.6304 16ZM19.4398 21C15.3896 21 12.1062 23.2386 12.1062 26C12.1062 27.1046 13.0016 28 14.1062 28H24.7734C25.878 28 26.7734 27.1046 26.7734 26C26.7734 23.2386 23.4901 21 19.4398 21ZM27.8175 14C28.3961 14 28.8652 14.4477 28.8652 15V16H29.9128C30.4914 16 30.9605 16.4477 30.9605 17C30.9605 17.5523 30.4914 18 29.9128 18H28.8652V19C28.8652 19.5523 28.3961 20 27.8175 20C27.2389 20 26.7698 19.5523 26.7698 19V18H25.7222C25.1436 18 24.6745 17.5523 24.6745 17C24.6745 16.4477 25.1436 16 25.7222 16H26.7698V15C26.7698 14.4477 27.2389 14 27.8175 14Z"
        fill={fill}
      />
    </svg>
  );
};

export default VolumeUserIcon;
